<template>
  <div class="fullheight">
    <eco-table
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      :selection="true"
      quick-search-props="tableOrForm,ip"
      :show-export="false"
      :show-custom-column="false"
      ref="ecoTable"
    >
      <template v-slot:toolbar>
        <el-button-group>
          <fe-delete-button url="${form}/formCodegenLog/v1/" :htTable="$refs.ecoTable">删除</fe-delete-button>
        </el-button-group>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column prop="tableOrForm" label="名称" :sortable="true" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <el-link type="primary" @click="showDialog(row.id)" title="查看详情">{{ row.tableOrForm }}</el-link>
          </template>
        </eco-table-column>
        <eco-table-column
          prop="type"
          label="生成类型"
          :filters="[
            { text: '表单', value: 'form' },
            { text: '物理表', value: 'table' }
          ]"
        >
          <template v-slot="{ row }">
            <el-tag type="primary" v-if="row.type == 'form'">表单</el-tag>
            <el-tag type="warning" v-else-if="row.type == 'table'">物理表</el-tag>
          </template>
        </eco-table-column>
        <eco-table-column prop="ip" label="操作IP" :sortable="true" :show-overflow-tooltip="true"></eco-table-column>
        <eco-table-column prop="createTime" label="操作时间" :sortable="true" :show-overflow-tooltip="true"></eco-table-column>
      </template>
    </eco-table>
    <eco-sidebar-dialog
      destroy-on-close
      width="28%"
      title="代码生成日志"
      class="sp-manager__dialog"
      :visible="dialogVisible"
      :before-close="beforeCloseDialog"
      append-to-body
    >
      <el-form v-form data-vv-scope="FormCodegenLogForm" style="padding: 20px">
        <eco-form-item label="生成类型">
          <el-tag type="primary" v-if="FormCodegenLog.type == 'form'">表单</el-tag>
          <el-tag type="warning" v-else-if="FormCodegenLog.type == 'table'">物理表</el-tag>
        </eco-form-item>
        <eco-form-item label="名称">{{ FormCodegenLog.tableOrForm }}</eco-form-item>
        <eco-form-item label="生成参数">
          <eco-input type="textarea" v-model="FormCodegenLog.opeContent" :rows="10" :readonly="true" />
        </eco-form-item>
        <eco-form-item label="操作IP">{{ FormCodegenLog.ip }}</eco-form-item>
        <eco-form-item label="操作人">{{ FormCodegenLog.createBy }}</eco-form-item>
        <eco-form-item label="操作时间">{{ FormCodegenLog.createTime }}</eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="beforeCloseDialog">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </eco-sidebar-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      data: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      FormCodegenLog: {}
    }
  },
  mounted() {
    this.$validator = this.$root.$validator
  },
  methods: {
    showDialog(id) {
      if (id) {
        this.$http.get('${form}/formCodegenLog/v1/' + id).then(
          (resp) => {
            this.FormCodegenLog = resp.data
            this.dialogVisible = true
          },
          (error) => {
            reject(error)
          }
        )
      }
    },
    beforeCloseDialog() {
      this.FormCodegenLog = {}
      this.dialogVisible = false
    },
    loadData(param, cb) {
      this.$http
        .post('${form}/formCodegenLog/v1/query', param)
        .then(
          (resp) => {
            let response = resp.data
            this.data = response.rows
            this.pageResult = {
              page: response.page,
              pageSize: response.pageSize,
              total: response.total
            }
          },
          (error) => {
            reject(error)
          }
        )
        .finally(() => cb())
    }
  }
}
</script>

<style lang="scss" scoped>
.sp-manager__dialog /deep/ > .el-dialog > .el-dialog__body {
  height: calc(100% - 170px);
}
</style>
